<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='学员月度绩效计算' label2="导入学员月度绩效计算" url="/achievement/monthly/stulist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">附件：</label>
            <div class="col-xl-10">
              <el-upload
                class="upload-demo"
                ref="upload"
                action
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :limit="1"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :http-request="submitFile"
                :auto-upload="false">
                <el-button slot="trigger" size="medium" type="primary">选取文件</el-button>
                <el-button style="margin-left: 10px;" size="medium" type="success" @click="submitUpload" v-loading.fullscreen.lock="fullscreenLoading">上传到服务器</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AchievementMonthlyImport',
  data () {
    return {
      form: {
        token: '',
        file: null
      },
      fileList: [],
      fullscreenLoading: false
    }
  },
  methods: {
    submitUpload: function () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit()
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    handleRemove: function (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview: function (file) {
      console.log(file)
    },
    beforeAvatarUpload: function (file) {
      console.log(file.type)
      const isXLS = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 'application/vnd.ms-excel'
      if (!isXLS) {
        this.$message({
          message: '上传文件只能是 xls/xlsx 格式!',
          type: 'error'
        })
      }
    },
    submitFile: function (param) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', param.file)
      console.log(formData)
      this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/UploadMoney', formData, {'Content-Type': 'multipart/form-data'})
        .then(res => {
          console.log(res.data)
          if (res.data.Code === 0) {
            this.$message({
              message: '上传成功',
              type: 'success'
            })
            console.log('上传成功')
            this.$router.push('/main/achievement/monthly/stulist')
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Data,
              type: 'error'
            })
          }
          this.fullscreenLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '上传失败',
            type: 'error'
          })
          this.fullscreenLoading = false
        })
    }
  },
  mounted: function () {
    this.form.token = sessionStorage.getItem('token')
  }
}
</script>

<style>
</style>
